import { useState, useEffect } from "react";
import { getSkillData, uploadSkill, deleteSkill } from "../../../service/api";
import "bootstrap/dist/css/bootstrap.min.css";
import { toast } from "react-toastify";
import Swal from "sweetalert2";

function Skill() {
  const [btnLoading, setBtnLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [skills, setSkill] = useState([]);
  const [inputValue, setInputValue] = useState("");

  // Fetch skills
  useEffect(() => {
    const fetchSkill = async () => {
      try {
        setLoading(true);
        const response = await getSkillData();
        console.log("Skills API Response:", response.data);
        setSkill(response.data?.skillsList || []);
      } catch (err) {
        console.error("Error fetching work skills:", err.message);
      } finally {
        setLoading(false);
      }
    };
    fetchSkill();
  }, []);

  // Add Skill
  const handleAddSkill = async (e) => {
    e.preventDefault();
    if (!inputValue.trim()) {
      toast.error("Please enter a skill");
      return;
    }

    try {
      setBtnLoading(true);
      const response = await uploadSkill({ skills: [inputValue.trim()] });
      toast.success(response.data.message || "Skill added successfully");

      // update local list
      setSkill((prev) => [...prev, { name: inputValue.trim() }]);
      setInputValue("");
    } catch (error) {
      toast.error(
        error.response?.data?.message || error.message || "Something went wrong"
      );
    } finally {
      setBtnLoading(false);
    }
  };

  // Delete Skill
  const handleDeleteSkill = async (skill) => {
    try {
      const response = await deleteSkill(skill);
      toast.success(response.data.message);
      setSkill((prev) => prev.filter((s) => s.name !== skill));
    } catch (error) {
      toast.error(
        error.response?.data?.message || error.message || "Something went wrong"
      );
    }
  };

  return (
    <div>
      {/* ---- Form ---- */}
      <form method="POST" action="" onSubmit={handleAddSkill}>
        <h4>Add Your Professional Skills</h4>
        <div className="hj-skill-form">
          <div className="hj-skill">
            <input
              type="text"
              id="skillSearch"
              className="form-control mb-3"
              placeholder="e.g. React, Node.js, MySQL"
              value={inputValue}
              onChange={(e) => setInputValue(e.target.value)}
            />
          </div>
          <div className="">
            <button type="submit" className="" disabled={btnLoading}>
              {btnLoading ? (
                <span>
                  <i className="fa fa-spinner fa-spin me-2"></i>
                  Adding...
                </span>
              ) : (
                "Add Skills"
              )}
            </button>
          </div>
        </div>
      </form>

      {/* ---- Skill List ---- */}
      <div className="row mt-4">
        {loading ? (
          <div className="text-center w-100 my-5">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        ) : skills.length === 0 ? (
          <p className="text-center w-100">No work skills found.</p>
        ) : (
          <div className="d-flex flex-wrap gap-1">
            {skills.map((skill, index) => (
              <span
                key={index}
                className="skill-badge d-flex align-items-center"
              >
                {skill.name}
                <button
                  style={{
                    backgroundColor: "inherit",
                    border: "none",
                    padding: 0,
                    marginLeft: "6px",
                  }}
                  className="delete-btn"
                  onClick={() =>
                    Swal.fire({
                      title: "Are you sure?",
                      text: "You won't be able to revert this!",
                      icon: "warning",
                      showCancelButton: true,
                      confirmButtonColor: "#d33",
                      cancelButtonColor: "#3085d6",
                      confirmButtonText: "Yes, delete it!",
                      cancelButtonText: "Cancel",
                    }).then((result) => {
                      if (result.isConfirmed) handleDeleteSkill(skill.name);
                    })
                  }
                >
                  <i className="fas fa-trash-alt text-danger"></i>
                </button>
              </span>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default Skill;
